
seedWebApp.controller('EditBoxCtrl', ['$scope', '$uibModalInstance', '$window', 'StoreService', '$timeout', 'order', 'box',
    function EditBoxCtrl($scope, $uibModalInstance, $window, StoreService, $timeout, order, box) {
        console.log('EditBoxCtrl');
        console.log(box);

        $scope.order = order;
        $scope.box = box;

        $scope.ok = function () {
            $uibModalInstance.close();
        };

        $scope.openNewTab = function (version) {
            var newUrl = version.Image;
            $window.open(newUrl, '_blank');
            $scope.cancel();
        };

        $scope.doPrint = function () {
            $window.print();
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

    }
]);